import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Header/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Preloader from "../Preloder/Preloader";
import Select from "react-select"; // ✅ correct
const Editprofile = () => {

  const navigate=useNavigate()
//  const location = useLocation();
    const location = useLocation();
  // Keep step on refresh
  const [step, setStep] = useState(() => {
    return Number(sessionStorage.getItem("step")) || 1;
  });

  useEffect(() => {
    sessionStorage.setItem("step", step);
  }, [step]);

  // Reset step when user navigates away from this page
  useEffect(() => {
    return () => {
      // cleanup runs ONLY on navigation, NOT on refresh
      sessionStorage.setItem("step", 1);
    };
  }, [location.pathname]);


  const userName = localStorage.getItem("username");
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_API_KEY;
  const formatTimeForInput = (timeStr) => {
    if (!timeStr) return "";
    return timeStr.slice(0, 5); // "04:34"
  };
  
  const { profileData, aadhaar, username, password } = location.state || {};

  // -------------------------
  // STATES
  // -------------------------
  const [school, setSchool] = useState("");
  const [schoolName, setSchoolName] = useState("");

  const [loading, setLoading] = useState(false); // FIXED SPELLING

  const [colleges, setColleges] = useState([{ collegeName: "", degree: "" }]);

  const [educationError, setEducationError] = useState("");

  const [designation, setDesignation] = useState("");
  const [yearsOfWork, setYearsOfWork] = useState("");
  const [workingLocation, setWorkingLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [salary, setSalary] = useState("");
  const [employedIn, setEmployedIn] = useState("");
  const [error, setError] = useState("");

  const [personalData, setPersonalData] = useState({
    // dateOfBirth: "",
    maritalStatus: "",
    height: "",
    weight: "",
    motherTongue: "",
    religion: "",
    caste: "",
    comunity: "",
    physicalStatus: "",
    aadhaar: aadhaar,
  });
  const [cast, setCast] = useState([]);
  const [community, setCommunity] = useState([]);
  const [believesInHoroscope, setBelievesInHoroscope] = useState("");
  const [horoscopeDetails, setHoroscopeDetails] = useState({
    dob: "",
    timeOfBirth: "",
    placeOfBirth: "",
    rasi: "",
    natchitheram: "",
    patham: "",
  });

  const [hasHoroscope, setHasHoroscope] = useState("");
  const [horoscopeFile, setHoroscopeFile] = useState(null);


   const [preview, setPreview] = useState("");
  const [previewpopup, setPreviewpopup] = useState(false);


  const [collegeData, setCollegeData] = useState([]);
   const [SiblingData, setSiblingData] = useState([]);
  const handleStep6Continue = async () => {
    setLoading(true);

    const apikey = process.env.REACT_APP_API_KEY;

    try {
      const formData = new FormData();
      formData.append("believes_in_horoscope", believesInHoroscope);
      formData.append("aadhaar", aadhaar); // Only if required
      if (believesInHoroscope === "yes") {
        formData.append("dob", horoscopeDetails.dob);
        formData.append("time_of_birth", horoscopeDetails.timeOfBirth);
        formData.append("place_of_birth", horoscopeDetails.placeOfBirth);
        formData.append("rasi", horoscopeDetails.rasi);
        formData.append("natchitheram", horoscopeDetails.natchitheram);
        formData.append("patham", horoscopeDetails.patham);
      }

      formData.append("has_horoscope_file", hasHoroscope);

      // ✅ Append file only if it exists and "yes" is selected
      if (hasHoroscope === "yes" && horoscopeFile) {
        formData.append("horoscope_file", horoscopeFile);
      }

      // ✅ DEBUG: Log FormData contents
      // console.log("📦 FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": ", pair[1]);
      }

      // ✅ Submit to API
      const response = await axios.post(
        "https://matrimony.bugchat.in/api/addhoroscopedetails",
        formData,
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("✅ API Response:", response.data.status);

      if (response.data.status === "Success") {
        setStep(step + 1);
      }
    } catch (error) {
      console.error("❌ Submission failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleStep5Continue = async () => {
    const requiredFields = [
      [personalData.maritalStatus, "Marital status is required."],
      [personalData.height, "Height is required."],
      [personalData.weight, "Weight is required."],
      [personalData.motherTongue, "Mother tongue is required."],
      [personalData.religion, "Religion is required."],
      [personalData.caste, "Caste is required."],
      [personalData.comunity, "Community is required."],
      [personalData.physicalStatus, "Physical status is required."],
      [personalData.aadhaar, "Aadhaar is required."],
    ];

    for (let [field, message] of requiredFields) {
      if (!field) {
        setError(message);
        return;
      }
    }

    const apikey = process.env.REACT_APP_API_KEY;
    // setStep(4)

    try {
      const response = await axios.post(
        "https://matrimony.bugchat.in/api/addpersonaldetails",
        personalData,
        {
          headers: {
            "x-api-key": apikey, // ✅ sent in headers
          },
        }
      );

      // console.log(response.data);

      if (response.data.status === "Success") {
        setStep(step + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  // -------------------------
  // ADD COLLEGE
  // -------------------------
  const addCollegeField = () => {
    setColleges([...colleges, { collegeName: "", degree: "" }]);
  };

  // -------------------------
  // REMOVE COLLEGE
  // -------------------------
  const removeCollegeField = (index) => {
    const updated = colleges.filter((_, i) => i !== index);
    setColleges(updated);
  };

  // -------------------------
  // CHANGE COLLEGE INPUT
  // -------------------------
  const handleCollegeChange = (index, field, value) => {
    const updated = [...colleges];
    updated[index][field] = value;
    setColleges(updated);
  };

  // -------------------------
  // FETCH USER DATA
  // -------------------------
  useEffect(() => {
    const getUserData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${api}/api/getusersdetails/${userName}`,
          {
            headers: {
              "x-api-key": apikey,
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response.data);

        // Parse college string → array
        const collegesArray = response.data.user.college_name
          .split(",")
          .map((item) => {
            const [name, degree] = item.split(" - ").map((x) => x.trim());
            return {
              collegeName: name || "",
              degree: degree || "",
            };
          });

        // Set school details
        setSchool(response.data.user.standard_name);
        setSchoolName(
          response.data.user.school_name || response.data.user.scholl_name
        );
        setEmployedIn(response.data.user.employeid);
        setDesignation(response.data.user.job_type);
        setWorkingLocation(response.data.user.location);
        setSalary(response.data.user.salary);
        setCompanyName(response.data.user.company_name);
        setYearsOfWork(response.data.user.year_of_work);
        setColleges(collegesArray);

        setPersonalData({
          maritalStatus: response.data.user.maritalstatus,
          height: response.data.user.height,
          weight: response.data.user.weight,
          motherTongue: response.data.user.mothertounge,
          religion: response.data.user.religion,
          caste: response.data.user.caste_name,
          comunity: response.data.user.comunity,
          physicalStatus: response.data.user.physical_status,
          aadhaar: aadhaar,
        });

        setBelievesInHoroscope(response.data.user.believes_in_horoscope);

        setHoroscopeDetails({
          dob: response.data.user.horoscope_dob,
          timeOfBirth: response.data.user.time_of_birth,
          placeOfBirth: response.data.user.place_of_birth,
          rasi: response.data.user.rasi,
          natchitheram: response.data.user.star,
          patham: response.data.user.patham,
        });

        setHasHoroscope(response.data.user.has_horoscope_file);
        setHoroscopeFile(response.data.user.horoscope_file);
 
        
     setFamilyData({
  aadhaar: aadhaar,
  father: {
    name: response.data.user.father_name,
    occupation: response.data.user.father_occupat,
    employedIn: response.data.user.father_employed_in,
    income: response.data.user.father_income,
  },
  mother: {
    name: response.data.user.mother_name,
    occupation: response.data.user.mother_occupat,
    employedIn: response.data.user.mother_employed_in,
    income: response.data.user.mother_income,
  },
  siblings: response.data.user.sibilings?.map((s) => ({
    name: s.name || "",
    relationType: s.relation_type || "",
    ageRelation: s.age_relation || "",
    occupation: s.occupation || "",
    employedIn: s.employed_in || "",
    income: s.income || "",
  })) || [],
});


      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getUserData();
  }, [api, apikey, userName]);

  // -------------------------
  // STEP 3 SUBMIT HANDLER
  // -------------------------
  const handleStep3Continue = async () => {
    // Validate Inputs
    if (!school || !schoolName) {
      setEducationError("Please fill all school details.");
      return;
    }

    for (let i = 0; i < colleges.length; i++) {
      const { collegeName, degree } = colleges[i];

      if (!collegeName || !degree) {
        setEducationError(
          `Please fill college name and degree for entry ${i + 1}.`
        );
        return;
      }
    }

    setEducationError("");
    setLoading(true);

    const educationDetails = {
      school,
      schoolName,
      colleges,
      aadhaar,
    };

    try {
      const response = await axios.post(
        "https://matrimony.bugchat.in/api/addprofiledetails",
        educationDetails,
        {
          headers: {
            "x-api-key": apikey,
          },
        }
      );

      if (response.data.status === "Success") {
        setStep(step + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleStep4Continue = async () => {
    const apikey = process.env.REACT_APP_API_KEY;
    // setStep(4)

    const requiredFields = [
      { field: employedIn, message: "Please select employment status." },
      { field: designation, message: "Please enter your job designation." },
      { field: yearsOfWork, message: "Please enter years of work experience." },
      {
        field: workingLocation,
        message: "Please enter your working location.",
      },
      { field: companyName, message: "Please enter your company name." },
      { field: salary, message: "Please enter your salary." },
    ];

    for (let item of requiredFields) {
      if (!item.field) return setError(item.message);
    }

    const employmentDetails = {
      employedIn,
      designation,
      yearsOfWork,
      workingLocation,
      companyName,
      salary,
      aadhaar,
    };
    try {
      const response = await axios.post(
        "https://matrimony.bugchat.in/api/addjobdetails",
        employmentDetails,
        {
          headers: {
            "x-api-key": apikey, // ✅ sent in headers
          },
        }
      );

      // console.log(response.data);

      if (response.data.status === "Success") {
        setStep(step + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const casteOptions = cast.map((item) => ({
    value: item.caste_name,
    label: item.caste_name,
  }));

  const communityOptions = community.map((item) => ({
    value: item.community_name,
    label: item.community_name,
  }));
  const heightOptions = [
    "4 ft - 121 cm",
    "4 ft 1 in - 124 cm",
    "4 ft 2 in - 127 cm",
    "4 ft 3 in - 129 cm",
    "4 ft 4 in - 132 cm",
    "4 ft 5 in - 134 cm",
    "4 ft 6 in - 137 cm",
    "4 ft 7 in - 139 cm",
    "4 ft 8 in - 142 cm",
    "4 ft 9 in - 144 cm",
    "4 ft 10 in - 147 cm",
    "4 ft 11 in - 149 cm",
    "5 ft - 152 cm",
    "5 ft 1 in - 154 cm",
    "5 ft 2 in - 157 cm",
    "5 ft 3 in - 160 cm",
    "5 ft 4 in - 162 cm",
    "5 ft 5 in - 165 cm",
    "5 ft 6 in - 167 cm",
    "5 ft 7 in - 170 cm",
    "5 ft 8 in - 172 cm",
    "5 ft 9 in - 175 cm",
    "5 ft 10 in - 177 cm",
    "5 ft 11 in - 180 cm",
    "6 ft - 182 cm",
    "6 ft 1 in - 185 cm",
    "6 ft 2 in - 187 cm",
    "6 ft 3 in - 190 cm",
    "6 ft 4 in - 193 cm",
    "6 ft 5 in - 195 cm",
    "6 ft 6 in - 198 cm",
    "6 ft 7 in - 200 cm",
    "6 ft 8 in - 203 cm",
    "6 ft 9 in - 205 cm",
    "6 ft 10 in - 208 cm",
    "6 ft 11 in - 210 cm",
    "7 ft - 213 cm",
  ];

  useEffect(() => {
    fetchCaste();
    fetchCommunity();
  }, []);

  // const apikey = process.env.REACT_APP_API_KEY;
  const fetchCaste = async () => {
    try {
      const response = await axios.get(
        "https://matrimony.bugchat.in/api/getcaste",
        {
          headers: {
            "x-api-key": apikey, // ✅ send it as custom header
          },
        }
      );

      setCast(response.data.caste_list);
      // console.log("Cast response", response.data.caste_list);
    } catch (error) {
      console.error("Failed to fetch caste data:", error);
    }
  };

  const fetchCommunity = async () => {
    try {
      const response = await axios.get(
        "https://matrimony.bugchat.in/api/getcommunity",
        {
          headers: {
            "x-api-key": apikey, // ✅ send it as custom header
          },
        }
      );

      setCommunity(response.data.caste_list);
    } catch (error) {
      console.error("Failed to fetch community data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalData((prev) => ({ ...prev, [name]: value }));
  };

  const [familyData, setFamilyData] = useState({
    aadhaar: aadhaar,
    father: {
      name: "",
      occupation: "",
      employedIn: "",
      income: "",
    },
    mother: {
      name: "",
      occupation: "",
      employedIn: "",
      income: "",
    },
    siblings: [
      // { name: "", relation: "", occupation: "", employedIn: "", income: "" },
      {
        name: "",
        relationType: "", // Brother or Sister
        ageRelation: "", // Younger or Elder
        occupation: "",
        employedIn: "",
        income: "",
      },
    ],
  });

  // Handle parent field changes
  const handleParentChange = (parent, field, value) => {
    setFamilyData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [field]: value,
      },
    }));
  };

  // Handle sibling changes
  const handleSiblingChange = (index, field, value) => {
    const updatedSiblings = [...familyData.siblings];
    updatedSiblings[index][field] = value;
    setFamilyData((prev) => ({
      ...prev,
      siblings: updatedSiblings,
    }));
  };

  // Add sibling
  const addSibling = () => {
    setFamilyData((prev) => ({
      ...prev,
      siblings: [
        ...prev.siblings,
        { name: "", relation: "", occupation: "", employedIn: "", income: "" },
      ],
    }));
  };

  // Remove sibling
  const removeSibling = (index) => {
    const updatedSiblings = [...familyData.siblings];
    updatedSiblings.splice(index, 1);
    setFamilyData((prev) => ({
      ...prev,
      siblings: updatedSiblings,
    }));
  };

  // Continue to next step
  const handleStep7Continue = async () => {
    // console.log("Family Data:", familyData);
    // setStep(step + 1);

    setLoading(true);

    const apikey = process.env.REACT_APP_API_KEY;
    try {
      const response = await axios.post(
        "https://matrimony.bugchat.in/api/addfamilydetails",
        familyData,
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("✅ API Response:", response.data.status);

      if (response.data.status === "Success") {
        setStep(step + 1);
      }
    } catch (error) {
      console.error("❌ Submission failed:", error);
    } finally {
      setLoading(false);
    }
  };


  const handlePreview = async () => {
    try {
      const response = await axios.get(
        `https://matrimony.bugchat.in/api/getpreview/${aadhaar}`,
        {
          headers: {
            "x-api-key": apikey,
          },
        }
      );

      const rawCollegeData = response.data.userdetails.user?.college_name;

      if (!rawCollegeData) {
        console.log("No college_name found");
        return;
      }

      // Split and structure college name + degree
      const entries = rawCollegeData.split(",").map((entry) => entry.trim());

      const formattedColleges = entries.map((entry) => {
        const [college, degree] = entry.split("-").map((item) => item.trim());
        return {
          college_name: college,
          degree: degree,
        };
      });

      // Set parsed data
      setCollegeData(formattedColleges);
      setPreview(response.data.userdetails);
      console.log("prevew", response.data.userdetails);
      setPreviewpopup(true);
      setStep((prev) => prev + 1);
      setSiblingData(response.data.userdetails.siblings);
      // console.log("Formatted College Data:", formattedColleges);
      // console.log("User details:", response.data.userdetails.user);
      // console.log("Siblings:", response.data.userdetails.siblings);
    } catch (error) {
      console.error("Error fetching preview:", error);
    }
  };
  return (
    <div>
      {loading && <Preloader />}

      <Header />

      <section>
        <div className="login pro-edit-update">
          <div className="container">
            <div className="row">
              <div className="inn">
                <div className="rhs">
                  <div className="form-login">
                    {/* STEP 1 */}
                    {step === 1 && (
                      <>
                        <h2 className="entry-form-title">
                          Username & Password
                        </h2>

                        <div className="add-entry-form-container">
                          <div className="form-row">
                            <div className="form-group">
                              <label>Username</label>
                              <input type="text" value={username} readOnly />
                            </div>

                            <div className="form-group">
                              <label>Password</label>
                              <input
                                type="text"
                                value="eg : dd-MM-Year"
                                readOnly
                              />
                              <p>
                                <span style={{ color: "red" }}>*</span> your
                                date of birth is your password
                              </p>
                            </div>
                          </div>

                          <div className="button-container">
                            <button disabled>⬅️ Previous</button>
                            <button onClick={() => setStep(2)}>
                              Continue ➡️
                            </button>
                          </div>
                        </div>
                      </>
                    )}

                    {/* STEP 2 */}
                    {step === 2 && (
                      <>
                        <h2 className="entry-form-title">Basic Details</h2>

                        <div className="add-entry-form-container">
                          <div className="form-row">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                value={profileData.full_name}
                                readOnly
                              />
                            </div>

                            <div className="form-group">
                              <label>Father's Name</label>
                              <input
                                type="text"
                                value={profileData.father_name}
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label>Gender</label>
                              <input
                                type="text"
                                value={profileData.sex}
                                readOnly
                              />
                            </div>

                            <div className="form-group">
                              <label>Date of Birth</label>
                              <input
                                type="text"
                                value={profileData.dateofbirth}
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label>State</label>
                              <input
                                type="text"
                                value={profileData.state}
                                readOnly
                              />
                            </div>

                            <div className="form-group">
                              <label>District</label>
                              <input
                                type="text"
                                value={profileData.district}
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label>Taluk</label>
                              <input
                                type="text"
                                value={profileData.village}
                                readOnly
                              />
                            </div>

                            <div className="form-group">
                              <label>Pincode</label>
                              <input
                                type="text"
                                value={profileData.pin_code}
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="button-container">
                            <button onClick={() => setStep(1)}>
                              ⬅️ Previous
                            </button>
                            <button onClick={() => setStep(3)}>
                              Continue ➡️
                            </button>
                          </div>
                        </div>
                      </>
                    )}

                    {/* STEP 3 */}
                    {step === 3 && (
                      <>
                        <h2 className="entry-form-title">
                          Educational Details
                        </h2>

                        <div className="add-entry-form-container">
                          <form onSubmit={(e) => e.preventDefault()}>
                            <div className="form-row">
                              <div className="form-group">
                                <label>Studied Standard</label>
                                <select
                                  value={school}
                                  onChange={(e) => setSchool(e.target.value)}
                                  required
                                >
                                  <option value="">Select Standard</option>
                                  {[
                                    "I",
                                    "II",
                                    "III",
                                    "IV",
                                    "V",
                                    "VI",
                                    "VII",
                                    "VIII",
                                    "IX",
                                    "X",
                                    "XI",
                                    "XII",
                                  ].map((s) => (
                                    <option key={s} value={s}>
                                      {s}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group">
                                <label>School Name</label>
                                <input
                                  type="text"
                                  value={schoolName}
                                  onChange={(e) =>
                                    setSchoolName(e.target.value)
                                  }
                                  required
                                />
                              </div>
                            </div>

                            {/* COLLEGES */}
                            <div className="college-header">
                              <h3>College Details</h3>
                              <button
                                type="button"
                                className="add-button"
                                onClick={addCollegeField}
                              >
                                ➕ Add College
                              </button>
                            </div>

                            {colleges.map((college, index) => (
                              <div className="form-row college-row" key={index}>
                                <div className="form-group">
                                  <label>College Name</label>
                                  <input
                                    type="text"
                                    value={college.collegeName}
                                    onChange={(e) =>
                                      handleCollegeChange(
                                        index,
                                        "collegeName",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Degree</label>
                                  <input
                                    type="text"
                                    value={college.degree}
                                    onChange={(e) =>
                                      handleCollegeChange(
                                        index,
                                        "degree",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="form-group cancel-group">
                                  <button
                                    type="button"
                                    className="cancel-button"
                                    onClick={() => removeCollegeField(index)}
                                  >
                                    ❌ Remove
                                  </button>
                                </div>
                              </div>
                            ))}

                            {educationError && (
                              <p style={{ color: "red" }}>{educationError}</p>
                            )}

                            <div className="button-container">
                              <button type="button" onClick={() => setStep(2)}>
                                ⬅️ Previous
                              </button>

                              <button
                                type="button"
                                onClick={handleStep3Continue}
                              >
                                Continue ➡️
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
                    {step === 4 && (
                      <>
                        <h2 className="entry-form-title">Job Details</h2>
                        <div className="add-entry-form-container">
                          <form onSubmit={(e) => e.preventDefault()}>
                            <div className="form-row">
                              <div className="form-group">
                                <label>Employed In</label>
                                <select
                                  value={employedIn}
                                  onChange={(e) =>
                                    setEmployedIn(e.target.value)
                                  }
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Business">Business</option>
                                  <option value="Defence">Defence</option>
                                  <option value="Government/PSC">
                                    Government / PSC
                                  </option>
                                  <option value="MNC">MNC</option>
                                  <option value="Not Working">
                                    Not Working
                                  </option>
                                  <option value="Private">Private</option>
                                  <option value="Self-Employed">
                                    Self-Employed
                                  </option>
                                </select>
                              </div>
                              <div className="form-group">
                                <label>Designation</label>
                                <input
                                  type="text"
                                  placeholder="e.g. Software Engineer"
                                  value={designation}
                                  onChange={(e) =>
                                    setDesignation(e.target.value)
                                  }
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Years of Work</label>
                                <input
                                  type="number"
                                  min="0"
                                  placeholder="e.g. 3"
                                  value={yearsOfWork}
                                  onChange={(e) =>
                                    setYearsOfWork(e.target.value)
                                  }
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Working Location</label>
                                <input
                                  type="text"
                                  placeholder="e.g. Chennai"
                                  value={workingLocation}
                                  onChange={(e) =>
                                    setWorkingLocation(e.target.value)
                                  }
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Company Name</label>
                                <input
                                  type="text"
                                  placeholder="e.g. TCS"
                                  value={companyName}
                                  onChange={(e) =>
                                    setCompanyName(e.target.value)
                                  }
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <label>Salary</label>
                                <input
                                  type="number"
                                  placeholder="e.g. 500000"
                                  value={salary}
                                  onChange={(e) => setSalary(e.target.value)}
                                  required
                                />
                              </div>
                            </div>

                            <div>
                              {error && (
                                <p
                                  style={{ color: "red", marginBottom: "15px" }}
                                >
                                  {error}
                                </p>
                              )}
                            </div>

                            <div className="button-container">
                              <button
                                type="button"
                                onClick={() => setStep(step - 1)}
                              >
                                ⬅️ Previous
                              </button>
                              <button
                                type="button"
                                onClick={handleStep4Continue}
                              >
                                Continue ➡️
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    )}

                    {step === 5 && (
                      <>
                        <h2 className="entry-form-title">Personal Details</h2>
                        <div className="add-entry-form-container">
                          <form onSubmit={(e) => e.preventDefault()}>
                            {/* Job Details */}

                            {/* Personal Details */}
                            <div className="form-row">
                              <div className="form-group">
                                <label>Mother Tongue</label>
                                <select
                                  name="motherTongue"
                                  value={personalData.motherTongue}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Tamil">Tamil</option>
                                  <option value="Malayalam">Malayalam</option>
                                  <option value="Assamese">Assamese</option>
                                  <option value="Bengali">Bengali</option>
                                  <option value="Bodo">Bodo</option>
                                  <option value="Dogri">Dogri</option>
                                  <option value="Gujarati">Gujarati</option>
                                  <option value="Hindi">Hindi</option>
                                  <option value="Kannada">Kannada</option>
                                  <option value="Kashmiri">Kashmiri</option>
                                  <option value="Konkani">Konkani</option>
                                  <option value="Maithili">Maithili</option>
                                  <option value="Manipuri">Manipuri</option>
                                  <option value="Marathi">Marathi</option>
                                  <option value="Nepali">Nepali</option>
                                  <option value="Odia">Odia</option>
                                  <option value="Punjabi">Punjabi</option>
                                  <option value="Sanskrit">Sanskrit</option>
                                  <option value="Santali">Santali</option>
                                  <option value="Sindhi">Sindhi</option>
                                  <option value="Telugu">Telugu</option>
                                  <option value="Urdu">Urdu</option>
                                  <option value="Other">Other</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label>Marital Status</label>
                                <select
                                  name="maritalStatus"
                                  value={personalData.maritalStatus}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Single">Single</option>
                                  {/* <option value="Married">Married</option> */}
                                  <option value="Divorced">Divorced</option>
                                  <option value="Widowed">Widowed</option>
                                </select>
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Height</label>
                                <select
                                  name="height"
                                  value={personalData.height}
                                  onChange={handleChange}
                                >
                                  <option value="">Select</option>
                                  {heightOptions.map((value) => (
                                    <option key={value} value={value}>
                                      {value}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group">
                                <label>Weight (kg)</label>
                                <input
                                  type="number"
                                  name="weight"
                                  placeholder="e.g. 65"
                                  value={personalData.weight}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Physical Status</label>
                                <select
                                  name="physicalStatus"
                                  value={personalData.physicalStatus}
                                  onChange={handleChange}
                                >
                                  <option value="">Select</option>
                                  <option value="Normal">Normal</option>
                                  <option value="Physically Challenged">
                                    Physically Challenged
                                  </option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label>Religion</label>
                                <select
                                  name="religion"
                                  value={personalData.religion}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Hindu">Hindu</option>
                                  <option value="Muslim">Muslim</option>
                                  <option value="Christian">Christian</option>
                                  <option value="Sikh">Sikh</option>
                                  <option value="Buddhist">Buddhist</option>
                                  <option value="Jain">Jain</option>
                                  <option value="Other">Other</option>
                                </select>
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>comunity</label>
                                <Select
                                  name="caste"
                                  options={communityOptions}
                                  value={communityOptions.find(
                                    (opt) => opt.value === personalData.comunity
                                  )}
                                  onChange={(selectedOption) =>
                                    setPersonalData((prev) => ({
                                      ...prev,
                                      comunity: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    }))
                                  }
                                  placeholder="Select comunity..."
                                  isClearable
                                  isSearchable
                                />
                              </div>
                              <div className="form-group">
                                <label>Caste</label>
                                <Select
                                  name="caste"
                                  options={casteOptions}
                                  value={casteOptions.find(
                                    (opt) => opt.value === personalData.caste
                                  )}
                                  onChange={(selectedOption) =>
                                    setPersonalData((prev) => ({
                                      ...prev,
                                      caste: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    }))
                                  }
                                  placeholder="Select caste..."
                                  isClearable
                                  isSearchable
                                />
                              </div>
                            </div>
                            <div>
                              <div>
                                {error && (
                                  <p
                                    style={{
                                      color: "red",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {error}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="button-container">
                              <button
                                type="button"
                                onClick={() => setStep(step - 1)}
                              >
                                ⬅️ Previous
                              </button>
                              <button
                                type="button"
                                onClick={handleStep5Continue}
                              >
                                Continue ➡️
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    )}

                    {step === 6 && (
                      <>
                        <h2 className="entry-form-title">Horoscope Details</h2>
                        <div className="add-entry-form-container">
                          <form onSubmit={(e) => e.preventDefault()}>
                            {/* Do you believe in horoscope? */}
                            <div className="form-row">
                              <div className="form-group">
                                <label>Do you believe in horoscopes?</label>
                                <select
                                  value={believesInHoroscope}
                                  onChange={(e) =>
                                    setBelievesInHoroscope(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </select>
                              </div>
                            </div>

                            {/* Horoscope detail inputs (conditionally shown) */}
                            {believesInHoroscope === "yes" && (
                              <>
                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Date of Birth</label>
                                    <input
                                      type="date"
                                      value={horoscopeDetails.dob}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          dob: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Time of Birth</label>
                                    <input
                                      type="time"
                                      // value={horoscopeDetails.timeOfBirth}
                                      value={formatTimeForInput(
                                        horoscopeDetails.timeOfBirth
                                      )}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          timeOfBirth: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Place of Birth</label>
                                    <input
                                      type="text"
                                      value={horoscopeDetails.placeOfBirth}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          placeOfBirth: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Rasi</label>
                                    <input
                                      type="text"
                                      value={horoscopeDetails.rasi}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          rasi: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Natchitheram</label>
                                    <input
                                      type="text"
                                      value={horoscopeDetails.natchitheram}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          natchitheram: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Patham</label>
                                    <input
                                      type="text"
                                      value={horoscopeDetails.patham}
                                      onChange={(e) =>
                                        setHoroscopeDetails((prev) => ({
                                          ...prev,
                                          patham: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Do you have a horoscope file?</label>
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="horoscopeCheck"
                                        value="yes"
                                        checked={hasHoroscope === "yes"}
                                        onChange={() => setHasHoroscope("yes")}
                                      />
                                      I have horoscope
                                    </label>
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="horoscopeCheck"
                                        value="no"
                                        checked={hasHoroscope === "no"}
                                        onChange={() => {
                                          setHasHoroscope("no");
                                          setHoroscopeFile(null);
                                        }}
                                      />
                                      I don't have
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* Horoscope file upload section */}

                            {/* Show file input if user has horoscope */}
                            {hasHoroscope === "yes" && (
                              <div className="form-row">
                                <div className="form-group">
                                  <label>
                                    Upload Horoscope File (Image or PDF)
                                  </label>
                                  <input
                                    type="file"
                                    accept="image/*,.pdf"
                                    onChange={(e) =>
                                      setHoroscopeFile(e.target.files[0])
                                    }
                                  />
                                  {horoscopeFile && (
                                    <p>Selected file: {horoscopeFile.name}</p>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Navigation buttons */}
                            <div className="button-container">
                              <button
                                type="button"
                                onClick={() => setStep(step - 1)}
                              >
                                ⬅️ Previous
                              </button>
                              <button
                                type="button"
                                onClick={handleStep6Continue}
                              >
                                Continue ➡️
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
                    {step === 7 && (
                      <>
                        <h2 className="entry-form-title">Family Details</h2>
                        <div className="add-entry-form-container">
                          <form onSubmit={(e) => e.preventDefault()}>
                            {/* Father Details */}
                            <div className="form-row">
                              <div className="form-group">
                                <label>Father Name</label>
                                <input
                                  type="text"
                                  value={familyData.father.name}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "father",
                                      "name",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>

                              <div className="form-group">
                                <label>Father's Occupation</label>
                                <input
                                  type="text"
                                  value={familyData.father.occupation}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "father",
                                      "occupation",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Employed In</label>
                                <select
                                  value={familyData.father.employedIn}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "father",
                                      "employedIn",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Business">Business</option>
                                  <option value="Defence">Defence</option>
                                  <option value="Government/PSC">
                                    Government / PSC
                                  </option>
                                  <option value="MNC">MNC</option>
                                  <option value="Not Working">
                                    Not Working
                                  </option>
                                  <option value="Private">Private</option>
                                  <option value="Self-Employed">
                                    Self-Employed
                                  </option>
                                  <option value="Retired">Retired</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label>Annual Income</label>
                                <input
                                  type="number"
                                  placeholder="e.g. 40000"
                                  value={familyData.father.income}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "father",
                                      "income",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <hr />

                            {/* Mother Details */}
                            <div className="form-row">
                              <div className="form-group">
                                <label>Mother's Name</label>
                                <input
                                  type="text"
                                  value={familyData.mother.name}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "mother",
                                      "name",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>

                              <div className="form-group">
                                <label>Mother's Occupation</label>
                                <input
                                  type="text"
                                  value={familyData.mother.occupation}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "mother",
                                      "occupation",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label>Employed In</label>
                                <select
                                  value={familyData.mother.employedIn}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "mother",
                                      "employedIn",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Business">Business</option>
                                  <option value="Defence">Defence</option>
                                  <option value="Government/PSC">
                                    Government / PSC
                                  </option>
                                  <option value="MNC">MNC</option>
                                  <option value="Not Working">
                                    Not Working
                                  </option>
                                  <option value="Private">Private</option>
                                  <option value="Self-Employed">
                                    Self-Employed
                                  </option>
                                  <option value="Retired">Retired</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label>Annual Income</label>
                                <input
                                  type="number"
                                  placeholder="e.g. 40000"
                                  value={familyData.mother.income}
                                  onChange={(e) =>
                                    handleParentChange(
                                      "mother",
                                      "income",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <hr />
                            <h3>Sibling Details</h3>

                            {familyData.siblings.map((sibling, index) => (
                              <div
                                key={index}
                                className="sibling-entry"
                                style={{
                                  marginBottom: "20px",
                                  border: "1px solid #ccc",
                                  padding: "15px",
                                  borderRadius: "5px",
                                }}
                              >
                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Sibling Name</label>
                                    <input
                                      type="text"
                                      value={sibling.name}
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                      required
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Age Relation</label>
                                    <select
                                      value={sibling.ageRelation}
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "ageRelation",
                                          e.target.value
                                        )
                                      }
                                      required
                                    >
                                      <option value="">Select</option>
                                      <option value="Younger">Younger</option>
                                      <option value="Elder">Elder</option>
                                    </select>
                                  </div>

                                  <div className="form-group">
                                    <label>Relation Type</label>
                                    <select
                                      value={sibling.relationType}
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "relationType",
                                          e.target.value
                                        )
                                      }
                                      required
                                    >
                                      <option value="">Select</option>
                                      <option value="Brother">Brother</option>
                                      <option value="Sister">Sister</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Occupation</label>
                                    <input
                                      type="text"
                                      value={sibling.occupation}
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "occupation",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Employed In</label>
                                    <select
                                      value={sibling.employedIn}
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "employedIn",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Business">Business</option>
                                      <option value="Defence">Defence</option>
                                      <option value="Government/PSC">
                                        Government / PSC
                                      </option>
                                      <option value="MNC">MNC</option>
                                      <option value="Not Working">
                                        Not Working
                                      </option>
                                      <option value="Private">Private</option>
                                      <option value="Self-Employed">
                                        Self-Employed
                                      </option>
                                      {/* <option value="Retired">Retired</option> */}
                                      <option value="student">student</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="form-row">
                                  <div className="form-group">
                                    <label>Annual Income</label>
                                    <input
                                      type="number"
                                      value={sibling.income}
                                      placeholder="e.g. 40000"
                                      onChange={(e) =>
                                        handleSiblingChange(
                                          index,
                                          "income",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  onClick={() => removeSibling(index)}
                                  style={{
                                    backgroundColor: "#ff4d4f",
                                    color: "white",
                                    padding: "6px 10px",
                                    marginTop: "10px",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  ❌ Remove Sibling
                                </button>
                              </div>
                            ))}

                            <button
                              type="button"
                              onClick={addSibling}
                              style={{
                                backgroundColor: "#4CAF50",
                                color: "white",
                                padding: "8px 14px",
                                border: "none",
                                marginBottom: "20px",
                                cursor: "pointer",
                              }}
                            >
                              ➕ Add Sibling
                            </button>

                            <div className="button-container">
                              <button
                                type="button"
                                onClick={() => setStep(step - 1)}
                              >
                                ⬅️ Previous
                              </button>
                              <button
                                type="button"
                                onClick={handleStep7Continue}
                              >
                                Continue ➡️
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    )}

                     {step === 8 && (
          <>
            <h2 className="entry-form-title">Preview & save</h2>
            <div className="add-entry-form-container">
              {/* <form onSubmit={(e) => e.preventDefault()}> */}
              <div className="button-container">
                <button type="button" onClick={handlePreview}>
                  👁️ Preview
                </button>
                <button type="button">Save ➡️</button>
              </div>
              {/* </form> */}
            </div>
          </>
        )}

           {preview && previewpopup && (
          <>
            <h2 className="entry-form-title">👁️ Preview</h2>
            <div className="add-entry-form-container">
              {/* Father's Name,Gender,Date of Birth,State,District,Taluk,Pincode */}
              <h5>Basic Details</h5>
              <div className="form-row">
                <div className="form-group">
                  <label>FULL NAME</label>
                  <input
                    type="text"
                    value={preview?.user?.full_name || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>FATHER NAME</label>
                  <input
                    type="text"
                    value={preview?.user?.father_name || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Gender</label>
                  <input type="text" value={preview?.user?.sex} readOnly />
                </div>
                <div className="form-group">
                  <label>Date of Birth</label>
                  <input
                    type="text"
                    value={preview?.user?.dateofbirth || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>District</label>
                  <input type="text" value={preview?.user?.district} readOnly />
                </div>
                <div className="form-group">
                  <label>pincode</label>
                  <input type="text" value={preview?.user?.pin_code} readOnly />
                </div>
              </div>
              <hr />
              <h5>Educational Details</h5>

              <div className="form-row">
                <div className="form-group">
                  <label>Studied Standard</label>
                  <input
                    type="text"
                    value={preview?.user?.standard_name}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>School Name</label>
                  <input
                    type="text"
                    value={preview?.user?.scholl_name || ""}
                    readOnly
                  />
                </div>
              </div>

              <h5>College Details</h5>

              {/* Dynamically render College Name & Degree pairs */}
              {collegeData.length > 0 && (
                <>
                  {collegeData.map((item, index) => (
                    <div className="form-row" key={index}>
                      <div className="form-group">
                        <label>College Name {index + 1}</label>
                        <input type="text" value={item.college_name} readOnly />
                      </div>

                      <div className="form-group">
                        <label>Degree {index + 1}</label>
                        <input type="text" value={item.degree} readOnly />
                      </div>
                    </div>
                  ))}
                </>
              )}

              <hr />
              <h5>Job Details</h5>

              <div className="form-row">
                <div className="form-group">
                  <label>Employed In</label>
                  <input
                    type="text"
                    value={preview?.user?.employeid || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Designation</label>
                  <input
                    type="text"
                    value={preview?.user?.job_type || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Years of Work</label>
                  <input
                    type="text"
                    value={preview?.user?.year_of_work || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Working Location</label>
                  <input
                    type="text"
                    value={preview?.user?.location || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Company Name</label>
                  <input
                    type="text"
                    value={preview?.user?.company_name || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Salary</label>
                  <input
                    type="text"
                    value={preview?.user?.salary || ""}
                    readOnly
                  />
                </div>
              </div>

              <hr />

              <h5>Personal Details</h5>

              <div className="form-row">
                <div className="form-group">
                  <label>Mother Tongue</label>
                  <input
                    type="text"
                    value={preview?.user?.mothertounge || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Marital Status</label>
                  <input
                    type="text"
                    value={preview?.user?.maritalstatus || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Height</label>
                  <input
                    type="text"
                    value={preview?.user?.height || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Weight (kg)</label>
                  <input
                    type="text"
                    value={preview?.user?.weight || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Physical Status</label>
                  <input
                    type="text"
                    value={preview?.user?.physical_status || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label> Religion</label>
                  <input
                    type="text"
                    value={preview?.user?.religion || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>comunity</label>
                  <input
                    type="text"
                    value={preview?.user?.comunity || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label> Caste</label>
                  <input
                    type="text"
                    value={preview?.user?.weight || ""}
                    readOnly
                  />
                </div>
              </div>

              {/* step - 6  */}
              <hr />
              <h5>Horoscope Details</h5>
              <div className="form-row">
                <div className="form-group">
                  <label>believes_in_horoscope</label>
                  <input
                    type="text"
                    value={preview?.user?.believes_in_horoscope || ""}
                    readOnly
                  />
                </div>
              </div>
              {/* <div className="form-group">
                    <label> Religion</label>
                     <input type="text" value={preview?.user?.religion || ""} readOnly/>
                  </div> */}
              {preview?.user?.believes_in_horoscope == "yes" && (
                <>
                  <div className="form-row">
                    <div className="form-group">
                      <label> Date of birth</label>
                      <input
                        type="text"
                        value={preview?.user?.horoscope_dob || ""}
                        readOnly
                      />
                    </div>

                    <div className="form-group">
                      <label> Time of Birth</label>
                      <input
                        type="text"
                        value={preview?.user?.time_of_birth || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label> Place of Birth</label>
                      <input
                        type="text"
                        value={preview?.user?.place_of_birth || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label> Rasi </label>
                      <input
                        type="text"
                        value={preview?.user?.rasi || ""}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Natchitheram</label>
                      <input
                        type="text"
                        value={preview?.user?.star || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label> Patham</label>
                      <input
                        type="text"
                        value={preview?.user?.patham || ""}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label> Do you have a horoscope file</label>
                      <input
                        type="text"
                        value={preview?.user?.has_horoscope_file || ""}
                        readOnly
                      />
                    </div>
                    {/* <h1>hi{preview?.user?.horoscope_file}</h1> */}
                    {preview?.user?.has_horoscope_file == "yes" && (
                      <>
                        <div className="form-group">
                          <label> Horoscope File </label>
                          {/* <input type="text" value={preview?.user?.has_horoscope_file || ""} readOnly/> */}
                          <img
                            src={`https://matrimony.bugchat.in/public/upload/${preview?.user?.horoscope_file}`}
                            alt="Horoscope"
                            //  className={isFullScreen ? 'full-screen-image' : 'thumbnail-image'}
                            //  onClick={toggleFullScreen}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <hr />
                  <h5>Family Details</h5>

                  <p>Father Details</p>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Father Name</label>
                      <input
                        type="text"
                        value={preview?.user?.father_name || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Father's Occupation</label>
                      <input
                        type="text"
                        value={preview?.user?.father_occupat || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Employed In</label>
                      <input
                        type="text"
                        value={preview?.user?.father_employed_in || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Annual Income</label>
                      <input
                        type="text"
                        value={preview?.user?.father_income || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <p>Mother Details</p>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Mother's Name</label>
                      <input
                        type="text"
                        value={preview?.user?.mother_name || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Mother's Occupation</label>
                      <input
                        type="text"
                        value={preview?.user?.mother_occupat || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Employed In</label>
                      <input
                        type="text"
                        value={preview?.user?.mother_employed_in || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Annual Income</label>
                      <input
                        type="text"
                        value={preview?.user?.mother_income || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <hr />
                 
                 {SiblingData.length > 0 && (
  <>
    <h5>Sibling Details</h5>

    {SiblingData.map((value, index) => (
      <div key={index}>
        <p>Sibling {index +1}</p>
        <div className="form-row">
          <div className="form-group">
            <label>Sibling Name</label>
            <input type="text" value={value.name || ""} readOnly />
          </div>

          <div className="form-group">
            <label>Age Relation</label>
            <input type="text" value={value.age_relation || ""} readOnly />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Relation Type</label>
            <input type="text" value={value.relation_type || ""} readOnly />
          </div>

          <div className="form-group">
            <label>Occupation</label>
            <input type="text" value={value.occupation || ""} readOnly />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Employed In</label>
            <input type="text" value={value.employed_in || ""} readOnly />
          </div>

          <div className="form-group">
            <label>Annual Income</label>
            <input type="text" value={value.income || ""} readOnly />
          </div>
        </div>

        <hr />
      </div>
    ))}
  </>
)}


                </>
              )}

              <div className="button-container">
                <button type="button"  onClick={()=>navigate('/login')}>Save ➡️</button>
              </div>
              {/* </form> */}
            </div>
          </>
        )}
                    {/* END OF STEPS */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Editprofile;
